import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import * as React from 'react';
import { MdFormatListNumbered } from 'react-icons/md';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ReportCategory } from 'app/area/case-report/case-listing/types';
import { isCaseViewModalOpen } from 'app/components/helpers';


interface FactItemActionProps extends ComponentProps, FactItemProps {
  tooltipClosedActions?: string;
  numberOfActions: ChildEntityCountShape;
  numberOfClosedActions: ChildEntityCountShape;
  reportCategory?: number;
}

export const ActionFactItem = (props: FactItemActionProps) => {
  const {
    tooltip,
    tooltipClosedActions,
    title,
    numberOfActions,
    numberOfClosedActions,
    url, 
    linkDomain,
    reportCategory,
    portalTarget
  } = props;

  const icon = <MdFormatListNumbered />;
  const items = [
    { value: numberOfActions?.count, tooltip },
    {
      value: numberOfClosedActions.count,
      tooltip: tooltipClosedActions,
      classNames: numberOfClosedActions.propName
    }
  ];  

  if (!numberOfActions?.count || reportCategory === ReportCategory.NumeratorReport) {
    return null;
  } 
  
  return (
    <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
      <BadgeList
        icon={icon}
        title={title}
        valueItems={items}
        portalTarget={portalTarget}
      />
    </FactLink>
  );
};
